import { mask } from "./mask";
import moment from "moment-timezone";

const numberFormatter = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const monetaryFormatter = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  currency: "BRL",
});
const percentageFormatter = new Intl.NumberFormat("pt-BR", {
  style: "percent",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function formatNumber(value) {
  return numberFormatter.format(value || 0);
}

export function formatNumberNull(value) {
  if (!value) {
    return "\u00A0";
  }

  return numberFormatter.format(value);
}

export function formatMonetary(value) {
  return monetaryFormatter.format(value || 0);
}

export function formatPercentage(value) {
  let adjustedValue = value || 0;

  adjustedValue = adjustedValue / 100.0;

  return percentageFormatter.format(adjustedValue);
}

//TODO: Podem ser utilizado nos campos existentes, para posterior implementação do método e ajustes automático.
//Begin
export function formatCEP(value) {
  if (!Boolean(value)) {
    return "";
  }

  return value;
}

export function formatCPF(value) {
  if (!Boolean(value)) {
    return "";
  }

  return mask(value, "###.###.###-##", true);
}

export function formatCNPJ(value) {
  if (!Boolean(value)) {
    return "";
  }

  return mask(value, "##.###.###/####-##");
}

export function formatCpfCnpj(value) {
  if (!Boolean(value)) {
    return "";
  }

  return value.length <= 11 ? formatCPF(value) : formatCNPJ(value);
}

export function formatDocumentTypeName(numeroCpfCnpj) {
  if (!Boolean(numeroCpfCnpj)) {
    return "";
  }
  return numeroCpfCnpj.length <= 11 ? "CPF" : "CNPJ";
}

export function formatPersonTypeName(numeroCpfCnpj) {
  if (!Boolean(numeroCpfCnpj)) {
    return "";
  }
  return numeroCpfCnpj.length <= 11 ? "Nome" : "Razão Social";
}

//End

export function timeStampToDate(timestamp) {
  if (!Boolean(timestamp)) {
    return null;
  }

  let data = new Date(timestamp);
  return `${data.getUTCDate().toString().padStart(2, "0")}/${(
    data.getUTCMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${data.getUTCFullYear()}`;
}

export function timeStampToDateWithTime(timestamp) {
  if (!Boolean(timestamp)) {
    return "";
  }

  let date = new Date(timestamp);
  let finalDate =
    date.toLocaleDateString("pt-BR") +
    " " +
    (date.getHours() < 10 ? "0" : "") +
    date.getHours() +
    ":" +
    (date.getMinutes() < 10 ? "0" : "") +
    date.getMinutes() +
    ":" +
    (date.getSeconds() < 10 ? "0" : "") +
    date.getSeconds();
  return finalDate;
}

export function timeStampToDateWithTimeUtc(timestamp) {
  if (!Boolean(timestamp)) {
    return "";
  }

  return moment.tz(timestamp, "UTC").format("DD/MM/YYYY HH:mm:ss");
}

export function formatPhone(phone) {
  if (!Boolean(phone)) {
    return "";
  }
  if (phone.length >= 10) {
    return new String(phone).replace(/(\d{2})(\d{4,5})(\d{4})/, "($1) $2-$3");
  }

  return phone;
}

export function formatPhoneWithDdd(ddd, phoneWithoutDdd) {
  let phone = "";
  if (phoneWithoutDdd) {
    if (ddd) {
      phone += ddd;
    }
    phone += phoneWithoutDdd;
  }

  return formatPhone(phone);
}

export function formatUpperCase(value) {
  if (typeof value == "string") {
    return value.toUpperCase();
  }

  return value;
}
